import { createAction, props } from '@ngrx/store';
import { editionData } from 'src/app/core/models';

export const LoadEditionData = createAction('[Edition] Load edition data');
export const LoadEditionDataSuccess = createAction('[Edition] Load edition data Success', props<{ editionData: editionData }>());
export const LoadEditionDataFail = createAction('[Edition] Load edition data Fail', props<{ error: any }>());
